import React, { useState, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "./ICTBasedLearning.css"; 
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";

// --- Mobile SVG Icons ---
const MobIctIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-tab-svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" />
  </svg>
);

const MobProjectIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-tab-svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
  </svg>
);

const MobUsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-tab-svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
  </svg>
);

const MobExperimentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-tab-svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
  </svg>
);

const MobResearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-tab-svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zm-7.518-.267A8.25 8.25 0 1120.25 10.5M8.288 14.212A5.25 5.25 0 1117.25 10.5" />
  </svg>
);

const MobPedagogyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-tab-svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
  </svg>
);

const FilterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" style={{width:'14px', height:'14px'}}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-9a3 3 0 11-6 0 3 3 0 016 0zm7.5 0a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const TargetIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-card-icon text-blue">
    <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 15h2.25m8.024-9.75c.011.05.028.1.052.148.591 1.2.924 2.55.924 3.977a8.96 8.96 0 01-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398C20.613 14.547 19.833 15 19 15h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 00.303-.54m.023-8.25H16.48a4.5 4.5 0 01-1.423-.23l-3.114-1.04a4.5 4.5 0 00-1.423-.23H6.504c-.328 0-.64.112-.883.328l-2.87 2.57a1.5 1.5 0 00-.338 1.839l2.514 4.19A1.5 1.5 0 006.215 15h3.084M15.75 2.25c-1.397 0-2.61.64-3.418 1.63M15.75 2.25a2.25 2.25 0 012.25 2.25M15.75 2.25v2.25M12 9A3 3 0 109 12a3 3 0 003-3z" />
  </svg>
);

const TrendingUpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-card-icon text-blue">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a1.196 1.196 0 001.691 0L21.75 4.5M21.75 4.5v5.25m0-5.25h-5.25" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 21h18" />
  </svg>
);

const MiniDesktopIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" style={{width:'18px', height:'18px', color: '#5865F2'}}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" />
  </svg>
);

const ICTBasedLearning = () => {
  const topRef = useRef(null);
  
  // Mobile Tool List State
  const [showAllTools, setShowAllTools] = useState(false);

  const learningMethods = [
    { id: "ict", title: "ICT Based\nLearning", Icon: MobIctIcon },
    { id: "project", title: "Project Based\nLearning", Icon: MobProjectIcon },
    { id: "participative", title: "Participative\nLearning", Icon: MobUsersIcon },
    { id: "experiential", title: "Experiential\nLearning", Icon: MobExperimentIcon },
    { id: "research", title: "Research Based\nLearning", Icon: MobResearchIcon },
  ];

  const teachingPedagogyMenu = [
    { id: "pedagogy", title: "Teaching\nPedagogy", Icon: MobPedagogyIcon },
    { id: "semester", title: "Semester\nCase Study", Icon: MobProjectIcon },
  ];

  const [activeTab, setActiveTab] = useState("ict");

  // === Image Path Variables for Dynamic Rendering ===
  const basePath = "/Academics/Teaching_Pedagogy";

  const participativeImages = [
    "imgi_2_image002.webp", "imgi_3_image004.webp", "imgi_4_image006.webp", "imgi_5_image008.webp", // Guest Lectures
    "imgi_6_image009.webp", "imgi_7_image012.webp", "imgi_8_image013.webp", "imgi_9_image015.webp"  // Green Club
  ];

  const synapseImages = [
    "imgi_10_image018.webp", "imgi_11_image020.webp", "imgi_12_image021.webp", "imgi_13_image023.webp"
  ];

  const ecellImages = [
    "imgi_14_image026.webp", "imgi_15_image028.webp"
  ];

  const dlleImages = [
    "imgi_16_image029.webp", "imgi_17_image031.webp", "imgi_18_image033.webp", "imgi_19_image036.webp", // Blood Donation / UDAAN / Labs
    "imgi_24_image046.webp", "imgi_25_image047.webp", "imgi_26_image049.webp", "imgi_27_image052.webp"  // INSEED / Rural visits
  ];

  const industryImages = [
    "imgi_20_image037.webp", "imgi_21_image039.webp", "imgi_22_image042.webp", "imgi_23_image044.webp"
  ];
  // ================================================

  const ictTableData = [
    { sr: 1, tool: "Google Classroom", purpose: "Virtual classroom for lectures and content sharing", source: "Google Classroom", course: "All Courses", badgeType: "blue" },
    { sr: 2, tool: "Google Meet / Google Jamboard / Microsoft Teams", purpose: "Conducting live lectures and webinars", source: "meet.google.com, jamboard.google.com, Microsoft Teams", course: "All Courses", badgeType: "blue" },
    { sr: 3, tool: "YouTube", purpose: "Repository for lecture videos and tutorials", source: "YouTube", course: "View Link", badgeType: "gray" },
    { sr: 4, tool: "Quizizz", purpose: "Conducting quizzes", source: "quizizz.com", course: "View Document", badgeType: "gray" },
    { sr: 5, tool: "GitHub", purpose: "Version control and code sharing", source: "github.com", course: "Programming, Projects", badgeType: "green" },
    { sr: 6, tool: "HackerRank", purpose: "Coding practice and problem solving", source: "hackerrank.com", course: "Programming Courses", badgeType: "green" },
    { sr: 7, tool: "Koha OPAC", purpose: "Accessing e-resources", source: "koha-opac.org", course: "Research Methodology", badgeType: "purple" },
    { sr: 8, tool: "EBSCOhost", purpose: "Accessing journals and e-books", source: "ebscohost.com", course: "Research Methodology", badgeType: "purple" },
    { sr: 9, tool: "Google Forms", purpose: "Surveys, feedback, and evaluations", source: "forms.google.com", course: "All Courses", badgeType: "blue" },
    { sr: 10, tool: "NPTEL / SWAYAM / freeCodeCamp", purpose: "Online certification and learning", source: "nptel.ac.in, swayam.gov.in, freecodecamp.org", course: "All Courses", badgeType: "blue" },
    { sr: 11, tool: "Exam.net", purpose: "Assessment", source: "exam.net", course: "IKS, AIML", badgeType: "orange" },
  ];

  const pedagogyData = [
    { id: 1, pedagogy: "Case Study Learning", impact: "Enhances analytical and problem-solving skills through real-world scenarios.", exampleText: "Case Study on Current Trends in Digital Marketing.", exampleList: ["Digital Marketing Essentials (ME-MCA-212)", "Advanced Digital Marketing (ME-MCA-222)"] },
    { id: 2, pedagogy: "Hands on Coding & Lab Sessions", impact: "Builds practical implementation skills and strengthens conceptual understanding.", exampleText: "", exampleList: ["Java for Software Development Lab (MM-MCA-L11)", "DevOps Lab (MM-MCA-L23)"] },
    { id: 3, pedagogy: "Video Recording for Lab Practice sessions / Youtube Videos", impact: "Enables self-paced learning and revision of complex topics anytime, anywhere", exampleText: "", exampleList: ["https://www.youtube.com/watch?v=GvvfM-j9fPo - Advanced Web Technology Lab (MM-MCA-L14)"] },
    { id: 4, pedagogy: "Group Discussions", impact: "Improves communication, teamwork, and critical thinking abilities.", exampleText: "", exampleList: ["Communication & Soft Skill Development Lab (MM-MCA-L24)"] },
    { id: 5, pedagogy: "Mock Interviews", impact: "Boosts confidence, readiness, and performance in real interview situations.", exampleText: "", exampleList: ["Communication & Soft Skill Development Lab (MM-MCA-L24)"] },
    { id: 6, pedagogy: "Flipped Classroom", impact: "Promotes active learning by allowing students to learn theoretical concepts and engage in discussions, problem-solving, and application during class.", exampleText: "Visualgo: Enhances concept visualization and improves learning efficiency. –", exampleList: ["Algorithmic Data structure and Applications Lab (MM-MCA-L13)"] }
  ];

  const handleTabSelection = (id) => {
    setActiveTab(id);
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <Navbar />
      <CTAButton />
 <PageHeader 
            title="Teaching Pedagogy" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'Teaching Pedagogy' }]} 
          />
      {/* ========================================== */}
      {/* DESKTOP VIEW */}
      {/* ========================================== */}
      <div className="desktop-only ict-modern-portal">
        <div ref={topRef}>
         
        </div>

        <div className="ict-main-content">
          <aside className="ict-sidebar-modern">
            <div className="ict-sidebar-header-text">Learning Methods</div>
            <nav className="ict-nav-group">
              {learningMethods.map((nav) => (
                <button key={nav.id} className={`ict-nav-card ${activeTab === nav.id ? "is-active" : ""}`} onClick={() => handleTabSelection(nav.id)}>
                  <span className="ict-card-text">{nav.title.replace('\n', ' ')}</span>
                </button>
              ))}
            </nav>

            <div className="ict-sidebar-header-text">Teaching Pedagogy</div>
            <nav className="ict-nav-group">
              {teachingPedagogyMenu.map((nav) => (
                <button key={nav.id} className={`ict-nav-card ${activeTab === nav.id ? "is-active" : ""}`} onClick={() => handleTabSelection(nav.id)}>
                  <span className="ict-card-text">{nav.title.replace('\n', ' ')}</span>
                </button>
              ))}
            </nav>
          </aside>

          <main className="ict-viewer-area">
            {/* TAB 1: ICT Based Learning */}
            {activeTab === "ict" && (
              <div className="fade-in-section">
                <h2 className="ict-page-title">ICT Based Learning</h2>
                <p className="ict-page-desc">
                  ICT-Based Learning combines various teaching methods and models to create an effective and flexible learning experience. It leverages appropriate learning technologies ensuring that knowledge is delivered effectively to every learner.
                </p>

                <h3 style={{ color: "var(--tm-text)", fontSize: "1.1rem", marginBottom: "15px", marginTop: "20px" }}>
                  List of ICT Tools used for Teaching and Learning:
                </h3>

                <div className="ict-table-container">
                  <table className="ict-data-table">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>ICT Tool</th>
                        <th>Purpose / Application</th>
                        <th>Source / Platform</th>
                        <th>Courses / Subjects</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ictTableData.map((row) => (
                        <tr key={row.sr}>
                          <td>{row.sr}</td>
                          <td>{row.tool}</td>
                          <td>{row.purpose}</td>
                          <td>{row.source}</td>
                          <td><span className={`ict-badge ict-badge-${row.badgeType}`}>{row.course}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="ict-cards-grid">
                  <div className="ict-info-card">
                    <h3>Objective</h3>
                    <ul>
                      <li>To integrate technology-enabled tools for effective content delivery, collaboration, and assessment.</li>
                      <li>To enhance student engagement and digital competency through interactive and flexible learning platforms.</li>
                      <li>To develop self-directed learning skills using diverse ICT applications.</li>
                    </ul>
                  </div>
                  <div className="ict-info-card">
                    <h3>Outcome</h3>
                    <ul>
                      <li>Students effectively apply digital tools and platforms to communicate, collaborate, and manage learning tasks.</li>
                      <li>Learners demonstrate critical use of technology to solve academic and real-world problems efficiently.</li>
                      <li>Students build adaptability and continuous learning habits, preparing them for evolving technological environments.</li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {/* TAB 2: Project Based Learning */}
            {activeTab === "project" && (
              <div className="fade-in-section">
                <h2 className="ict-page-title">Project Based Learning</h2>
                <div style={{ marginBottom: "35px" }}>
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>Practical Labs:</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "20px" }}>In practical subjects, Project-Based Learning (PBL) enables students to apply classroom concepts to real-world problems through hands-on projects. Working individually or in teams, they design and develop practical solutions, enhancing their technical, problem-solving, and teamwork skills while gaining a deeper understanding of the subject.</p>
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>Capstone Project:</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "20px" }}>Under the Project-Based Learning (PBL) approach, students complete a capstone project throughout the semester that integrates classroom concepts with practical application. Guided by faculty mentors, they identify a real-world problem, design and implement a solution, and present their outcomes. This process enhances problem-solving, creativity, teamwork, and technical skills while fostering a deeper understanding of the subject and hands-on learning experience.</p>
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>Internship:</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "20px" }}>Students undertake a full-term internship during their 4th semester. This internship serves as a bridge between academic learning and professional practice, allowing students to apply their technical knowledge and skills in real industry environments.</p>
                </div>
                <div className="ict-cards-grid">
                  <div className="ict-info-card">
                    <h3>Objectives</h3>
                    <ul>
                      <li>To enable students to apply theoretical knowledge to real-world problems through hands-on projects.</li>
                      <li>To develop technical competence, problem-solving, and innovation skills using practical and team-based approaches.</li>
                      <li>To encourage collaboration, communication, and project management abilities in a professional context.</li>
                    </ul>
                  </div>
                  <div className="ict-info-card">
                    <h3>Outcomes</h3>
                    <ul>
                      <li>Students design and implement practical solutions demonstrating integration of technical and analytical skills.</li>
                      <li>Learners exhibit creativity, teamwork, and adaptability in project execution and presentation.</li>
                      <li>Students gain experiential understanding of concepts through structured project development and reflection.</li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {/* TAB 3: Participative Learning */}
            {activeTab === "participative" && (
              <div className="fade-in-section">
                <h2 className="ict-page-title">Participative Learning</h2>
                <div style={{ marginBottom: "35px" }}>
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>Guest Lecture:</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "20px" }}>Guest lectures provide students with interactive sessions led by industry experts, offering insights into current trends and real-world practices. These sessions encourage students to engage in dialogue, ask questions, and learn through discussion and reflection, bridging the gap between academic learning and industry expectations. These sessions cover diverse domains such as emerging technologies (AI, IoT, blockchain, cybersecurity), career and professional development (campus-to-corporate transition, digital marketing, overseas education), leadership and innovation (design thinking, agile transformation), and societal awareness (mental health, sustainability, women’s wellness), enriching both technical and holistic learning.</p>
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>Green Club:</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "20px" }}>Conducts eco-friendly initiatives such as tree plantations, beach clean-ups, and awareness drives.</p>
                </div>
                <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "10px" }}>Gallery</h3>
                <div className="ict-photo-grid">
                  {participativeImages.map((img, idx) => (
                    <div key={idx} className="ict-photo-item">
                      <img src={`${basePath}/${img}`} alt={`Participative Learning Event ${idx + 1}`} />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* TAB 4: Experiential Learning */}
            {activeTab === "experiential" && (
              <div className="fade-in-section">
                <h2 className="ict-page-title">Experiential Learning</h2>
                <p className="ict-page-desc" style={{ marginBottom: "40px" }}>Experiential Learning at TIMSCDR focuses on learning through real-world experiences such as industrial visits, professional chapters, student clubs. It enables students to apply theoretical knowledge in practical settings, enhancing their problem-solving, teamwork, and professional skills.</p>
                
                <div style={{ marginBottom: "50px" }}>
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>Synapse :</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "15px" }}>SYNAPSE event is organised every year. The event is designed to innovate and create unique IT products. Synapse encourages students to think ‘out-of-box’.</p>
                  <div className="ict-photo-grid">
                    {synapseImages.map((img, idx) => (
                      <div key={`synapse-${idx}`} className="ict-photo-item">
                        <img src={`${basePath}/${img}`} alt={`Synapse Event ${idx + 1}`} />
                      </div>
                    ))}
                  </div>
                </div>

                <div style={{ marginBottom: "50px" }}>
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>E-Cell (Entrepreneurship Cell):</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "15px" }}>To promote a sense of Entrepreneurship amongst the students. The main purpose of the event is to provide a platform for students to showcase and sell their products and improve their entrepreneurship skills.</p>
                  <div className="ict-photo-grid">
                    {ecellImages.map((img, idx) => (
                      <div key={`ecell-${idx}`} className="ict-photo-item">
                        <img src={`${basePath}/${img}`} alt={`E-Cell Event ${idx + 1}`} />
                      </div>
                    ))}
                  </div>
                </div>

                <div style={{ marginBottom: "50px" }}>
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>DLLE (Department of Lifelong Learning and Extension):</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "15px" }}>TIMSCDR fosters social awareness through collaborations with NGOs like INSEED and initiatives such as the DLLE program. These projects empower underprivileged communities and engage students in teaching and skill development activities.</p>
                  <div className="ict-photo-grid">
                    {dlleImages.map((img, idx) => (
                      <div key={`dlle-${idx}`} className="ict-photo-item">
                        <img src={`${basePath}/${img}`} alt={`DLLE Event ${idx + 1}`} />
                      </div>
                    ))}
                  </div>
                </div>

                <div style={{ marginBottom: "50px" }}>
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>Industrial visits:</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "15px" }}>It provides students with real-world exposure, linking classroom learning to industry practices and preparing them for professional careers.</p>
                  <div className="ict-photo-grid">
                    {industryImages.map((img, idx) => (
                      <div key={`industry-${idx}`} className="ict-photo-item">
                        <img src={`${basePath}/${img}`} alt={`Industrial Visit ${idx + 1}`} />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="ict-cards-grid">
                  <div className="ict-info-card">
                    <h3>Objectives</h3>
                    <ul>
                      <li>To enhance learning through direct, real-world experiences that connect theory with practical application.</li>
                      <li>To develop entrepreneurial, social, and professional competencies through activities like E-Cell, DLLE, INSEED, and industrial visits.</li>
                      <li>To foster innovation, teamwork, and community engagement by involving students in projects and events that address real-life challenges.</li>
                    </ul>
                  </div>
                  <div className="ict-info-card">
                    <h3>Outcomes</h3>
                    <ul>
                      <li>Students apply classroom knowledge to practical contexts, improving problem-solving and decision-making skills.</li>
                      <li>Learners demonstrate entrepreneurial thinking, creativity, and leadership through participation in events like E-Cell and Synapse.</li>
                      <li>Students cultivate social awareness and responsibility by engaging in community and rural development initiatives under DLLE, INSEED, and Unnat Bharat Abhiyan.</li>
                      <li>Participants gain professional exposure and teamwork experience, preparing them for successful careers in dynamic environments.</li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {/* TAB 5: Research Based Learning */}
            {activeTab === "research" && (
              <div className="fade-in-section">
                <h2 className="ict-page-title">Research Based Learning</h2>
                <p className="ict-page-desc" style={{ marginBottom: "40px" }}>Under the Research-Based Learning (RBL) approach, students actively engage in exploring new ideas through the Research, Innovation, and Technology Lab. They are encouraged to investigate emerging technologies, develop innovative solutions, and contribute to knowledge creation. Students participate in activities such as preparing research posters, presenting their findings, and publishing research papers in conferences or journals. This hands-on exposure to research nurtures critical thinking, analytical skills, and innovation, while fostering a spirit of inquiry and lifelong learning.</p>

                <div style={{ marginBottom: "35px" }}>
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>Research, Innovation and Technology Lab (RITL):</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "20px" }}>The RIT Lab aims to foster innovation and technological advancement by promoting hands-on learning in IoT and emerging technologies. It encourages students and faculty to design, develop, and implement IoT-based in-house projects, enhancing practical skills, creativity, and research-oriented thinking.</p>
                  
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>Research Poster Presentation at International Conference:</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "20px" }}>During the International Conference on Advances in Information and Management (ICAIM) organized by TIMSCDR, students present research posters showcasing their innovative ideas and findings on emerging technologies and management topics. These posters visually summarize their research objectives, methodology, and outcomes, helping students develop analytical and presentation skills while fostering a culture of inquiry and creativity.</p>
                  
                  <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>Research Paper Presentation at International Conference:</h3>
                  <p className="ict-page-desc" style={{ marginBottom: "20px" }}>As part of ICAIM, students also author and present research papers that are reviewed and published in conference proceedings or reputed journals. This platform allows them to engage in academic writing, data analysis, and critical evaluation, promoting research aptitude and preparing them for future scholarly and professional pursuits.</p>
                </div>

                <div className="ict-cards-grid">
                  <div className="ict-info-card">
                    <h3>Objectives</h3>
                    <ul>
                      <li>To promote inquiry-driven learning that encourages exploration and innovation in emerging technologies.</li>
                      <li>To develop analytical, problem-solving, and academic writing skills through hands-on research activities.</li>
                      <li>To foster a spirit of innovation and independent thinking among students.</li>
                    </ul>
                  </div>
                  <div className="ict-info-card">
                    <h3>Outcomes</h3>
                    <ul>
                      <li>Students apply systematic research methods to analyse and propose effective solutions to real-world problems.</li>
                      <li>Learners demonstrate critical thinking, creativity, and data-driven decision-making in their research work.</li>
                      <li>Students showcase professional communication and teamwork through research posters, papers, and presentations.</li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {/* TAB 6: Teaching Pedagogy */}
            {activeTab === "pedagogy" && (
              <div className="fade-in-section">
                <h2 className="ict-page-title">Teaching Pedagogy</h2>
                <div className="ict-table-container" style={{ marginTop: "20px" }}>
                  <table className="ict-pedagogy-table">
                    <thead>
                      <tr>
                        <th style={{ width: "25%" }}>Teaching Pedagogy</th>
                        <th style={{ width: "35%" }}>Impact</th>
                        <th style={{ width: "40%" }}>Example</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pedagogyData.map((row) => (
                        <tr key={row.id}>
                          <td className="ict-pedagogy-text-bold">{row.pedagogy}</td>
                          <td>{row.impact}</td>
                          <td>
                            {row.exampleText && <span>{row.exampleText}</span>}
                            {row.exampleList && row.exampleList.length > 0 && (
                              <ul className="ict-pedagogy-list">
                                {row.exampleList.map((item, idx) => (<li key={idx}>{item}</li>))}
                              </ul>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

 {activeTab === "semester" && (
              <div className="fade-in-section">
                <h2 className="ict-page-title">Semester Case Study: SYNAPSE</h2>
                <p className="ict-page-desc" style={{ marginBottom: "20px" }}>
                  TIMSCDR conceptualized the event <strong>“SYNAPSE – junction between two neurons – Technology and Innovations”</strong> to inculcate self-learning, innovation and entrepreneurship amongst it’s students and has been organizing it every year since 2011.
                </p>
                <p className="ict-page-desc" style={{ marginBottom: "20px" }}>
                  In Synapse all students are divided into groups and each group has to design and develop prototype of an IT related unique product with a distinct application for which financial assistance is given. Students study any relevant problem area, usually pertaining to prevalent environmental or societal concern, propose a solution along with its feasibility study and then design a prototype solution for it. The event also aims at enhancing other important skills of the students like creativity, team work, cost effectiveness, communication skills and how they convert their theoretical knowledge to practical approach and encourage students to think of out of the box solutions. A faculty mentor is assigned to each group who interacts and guides the students during the entire process.
                </p>

                <h3 style={{ color: "var(--tm-text)", fontSize: "1.2rem", marginBottom: "8px" }}>Stages of SYNAPSE</h3>
                <p className="ict-page-desc" style={{ marginBottom: "15px" }}>
                  SYNAPSE consists of two stages– <strong>Curtain Raiser</strong> and <strong>Final Presentation</strong>. During curtain raiser, students are expected to present problem identified, feasibility study conducted, survey (if applicable) to identify problem, solution proposed, proposed work break down structure, societal or business impact expected. Products are mentored by faculty members regularly and by industry professionals periodically, wherein they give suggestions to improve the final prototype of the product. Students are able to incorporate all suggestions before the final presentation.
                </p>
                <p className="ict-page-desc" style={{ marginBottom: "15px" }}>
                  100% students participate in curtain raiser and shortlisted projects in final presentation. Few projects are shortlisted from the projects showcased in the curtain raiser which then participate in the final presentation. During final presentation, students present –
                </p>
                <ul className="ict-page-desc" style={{ paddingLeft: "20px", marginBottom: "20px" }}>
                  <li>Existing system / Problem statement</li>
                  <li>Proposed system and its USP</li>
                  <li>Feasibility study</li>
                  <li>Deployment / Plan of execution</li>
                  <li>Prototype</li>
                  <li>Societal or business impact (ROI) expected</li>
                  <li>Future scope/enhancement</li>
                  <li>Banner (used for marketing)</li>
                  <li>Presentation, teamwork and communication.</li>
                </ul>
                <p className="ict-page-desc" style={{ marginBottom: "15px" }}>
                  Curtain raiser and final presentation both are mentored and evaluated by industry professionals on parameters such as uniqueness, originality, feasibility, finance management, promotional tactics which include advertisements.
                </p>
                <p className="ict-page-desc" style={{ marginBottom: "30px" }}>
                  The winning teams of Synapse are given certificate and cash prize. The projects showcased in final presentation are also published in the booklet printed by TIMSCDR – “SYNAPSE – Innovation Magazine”.
                </p>

                <div className="ict-cards-grid" style={{ marginBottom: "25px" }}>
                  <div className="ict-info-card">
                    <h3>Objectives</h3>
                    <ul>
                      <li>To promote innovation and self-learning among students by encouraging them to identify real-world problems and design IT-based prototype solutions.</li>
                      <li>To inculcate an entrepreneurial mindset by motivating students to conceptualize, design, and present innovative products with business and societal relevance.</li>
                      <li>To provide hands-on experience in the product development life cycle — from problem identification, feasibility analysis, and design to prototype implementation and presentation.</li>
                      <li>To bridge the gap between theoretical knowledge and practical application by guiding students to translate classroom learning into workable solutions.</li>
                      <li>To enhance essential professional skills such as teamwork, creativity, communication, time management, cost-effectiveness, and presentation abilities.</li>
                      <li>To foster industry-academia collaboration through continuous mentoring and evaluation by senior industry professionals and alumni.</li>
                      <li>To cultivate social and environmental responsibility by encouraging students to focus their innovations on current societal and ecological challenges.</li>
                      <li>To encourage holistic student development by engaging them in multidisciplinary problem-solving and real-world application of emerging technologies.</li>
                      <li>To create a platform for recognition and dissemination of innovative ideas through publication of selected projects in the “SYNAPSE TIMSCDR Innovations.”</li>
                    </ul>
                  </div>
                  
                  <div className="ict-info-card">
                    <h3>Outcomes</h3>
                    <ul>
                      <li>Students implement entire product development life cycle, from conceptualization to prototype development</li>
                      <li>Students learn to analyse multidisciplinary problems and to design and develop software solutions using emerging tools and technologies</li>
                      <li>Inculcating self-learning, innovation and entrepreneurship in students</li>
                      <li>Inculcating team spirit and develop communication skills in students</li>
                      <li>In some cases, students take their Synapse idea ahead and develop them into projects and research papers.</li>
                      <li>Synapse theme that is selected every year is focused on relevant societal or environmental concern. Students study prevalent issues and design their solutions accordingly</li>
                      <li>Senior Industry professionals, entrepreneurs and TIMSCDR alumni working in companies such as Mahindra & Mahindra Financial Services Limited, TCS, Nomura, L&T InfoTech mentor and evaluate Synapse projects which helps students develop an understanding from Industry perspective</li>
                      <li>The event provides a platform for Industry-Academia interaction</li>
                    </ul>
                  </div>
                </div>

                <div className="ict-info-card" style={{ marginBottom: "30px" }}>
                    <h3>Unique Features</h3>
                    <ul>
                      <li>100% student participation</li>
                      <li>Providing seed money all groups to develop prototype</li>
                      <li>Continuous mentoring by faculty</li>
                      <li>Periodic mentoring and evaluation by Senior Industry professionals</li>
                      <li>Evaluation in multiple phases, with chance given to students to refine their product in every stage</li>
                      <li>Certificates and cash prize given to winners</li>
                      <li>Culmination of shortlisted ideas in booklet “SYNAPSE TIMSCDR Innovation”</li>
                    </ul>
                </div>
              </div>
            )}
            
          </main>
        </div>
      </div>

      {/* ========================================== */}
      {/* MOBILE VIEW */}
      {/* ========================================== */}
      <div className="mobile-only mob-learning-wrapper">
        

        {/* Horizontal Scroll Tabs (Contains ALL links) */}
        <div className="mob-on-this-page-container">
          <p className="mob-otp-label">ON THIS PAGE</p>
          <div className="mob-tabs-scroll">
            {[...learningMethods, ...teachingPedagogyMenu].map((tab) => {
              const IconComponent = tab.Icon;
              return (
                <div key={tab.id} className={`mob-tab-card ${activeTab === tab.id ? 'active' : ''}`} onClick={() => setActiveTab(tab.id)}>
                  <div className="mob-tab-icon-wrapper">
                    <IconComponent />
                  </div>
                  <p className="mob-tab-text">{tab.title.replace('Learning', '\nLearning')}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Mobile Main Content Area */}
        <div className="mob-tab-content">

          {/* TAB 1: ICT Based Learning */}
          {activeTab === "ict" && (
            <>
              <h2 className="mob-section-title">ICT Based Learning</h2>
              <p className="mob-section-desc">
                ICT-Based Learning combines various teaching methods and models to create an effective and flexible learning experience. It leverages appropriate learning technologies ensuring that knowledge is delivered effectively to every learner.
              </p>

              {/* Tools Header */}
              <div className="mob-tools-header">
                <div className="mob-tools-title">
                  <MiniDesktopIcon /> List of ICT Tools used for Teaching and Learning:
                </div>
              </div>

              {/* Tools List (Mobile Cards) */}
              <div className="mob-tools-list">
                {(showAllTools ? ictTableData : ictTableData.slice(0, 5)).map((tool) => (
                  <div key={tool.sr} className="mob-tool-row">
                    <div className="mob-tool-sr-box">
                      <div className="mob-tool-sr">{tool.sr}</div>
                    </div>
                    <div className="mob-tool-info">
                      <h4 className="mob-tool-name">{tool.tool}</h4>
                      <p className="mob-tool-purpose">{tool.purpose}</p>
                    </div>
                    <div className="mob-tool-action">
                      <span className={`mob-badge mob-badge-${tool.badgeType}`}>{tool.course}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="mob-chevron-down">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                      </svg>
                    </div>
                  </div>
                ))}
              </div>
              
              <button className="mob-view-all-btn" onClick={() => setShowAllTools(!showAllTools)}>
                {showAllTools ? "Show less" : `View all ${ictTableData.length} tools`}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="mob-chevron-down-blue" style={{ transform: showAllTools ? 'rotate(180deg)' : 'none' }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </button>

              {/* Objective / Outcome Cards */}
              <div className="mob-obj-container">
                <div className="mob-obj-card">
                  <div className="mob-obj-icon-box"><TargetIcon /></div>
                  <div className="mob-obj-content">
                    <h3 className="mob-obj-title">OBJECTIVE</h3>
                    <ul className="mob-obj-list">
                      <li>To integrate technology-enabled tools for effective content delivery, collaboration, and assessment.</li>
                      <li>To enhance student engagement and digital competency through interactive and flexible learning platforms.</li>
                      <li>To develop self-directed learning skills using diverse ICT applications.</li>
                    </ul>
                  </div>
                </div>

                <div className="mob-obj-card">
                  <div className="mob-obj-icon-box"><TrendingUpIcon /></div>
                  <div className="mob-obj-content">
                    <h3 className="mob-obj-title">OUTCOME</h3>
                    <ul className="mob-obj-list">
                      <li>Students effectively apply digital tools and platforms to communicate, collaborate, and manage learning tasks.</li>
                      <li>Learners demonstrate critical use of technology to solve academic and real-world problems efficiently.</li>
                      <li>Students build adaptability and continuous learning habits, preparing them for evolving technological environments.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* TAB 2: Project Based Learning */}
          {activeTab === "project" && (
            <>
              <h2 className="mob-section-title">Project Based Learning</h2>
              <h3 className="mob-subsection-title">Practical Labs:</h3>
              <p className="mob-section-desc">In practical subjects, Project-Based Learning (PBL) enables students to apply classroom concepts to real-world problems through hands-on projects. Working individually or in teams, they design and develop practical solutions, enhancing their technical, problem-solving, and teamwork skills.</p>
              
              <h3 className="mob-subsection-title">Capstone Project:</h3>
              <p className="mob-section-desc">Under the Project-Based Learning (PBL) approach, students complete a capstone project throughout the semester that integrates classroom concepts with practical application. Guided by faculty mentors, they identify a real-world problem, design and implement a solution, and present their outcomes.</p>
              
              <h3 className="mob-subsection-title">Internship:</h3>
              <p className="mob-section-desc">Students undertake a full-term internship during their 4th semester. This internship serves as a bridge between academic learning and professional practice, allowing students to apply their technical knowledge and skills in real industry environments.</p>

              <div className="mob-obj-container">
                <div className="mob-obj-card">
                  <div className="mob-obj-icon-box"><TargetIcon /></div>
                  <div className="mob-obj-content">
                    <h3 className="mob-obj-title">OBJECTIVE</h3>
                    <ul className="mob-obj-list">
                      <li>To enable students to apply theoretical knowledge to real-world problems through hands-on projects.</li>
                      <li>To develop technical competence, problem-solving, and innovation skills.</li>
                      <li>To encourage collaboration, communication, and project management abilities.</li>
                    </ul>
                  </div>
                </div>
                <div className="mob-obj-card">
                  <div className="mob-obj-icon-box"><TrendingUpIcon /></div>
                  <div className="mob-obj-content">
                    <h3 className="mob-obj-title">OUTCOME</h3>
                    <ul className="mob-obj-list">
                      <li>Students design and implement practical solutions demonstrating integration of technical skills.</li>
                      <li>Learners exhibit creativity, teamwork, and adaptability in project execution.</li>
                      <li>Students gain experiential understanding of concepts through structured project development.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* TAB 3: Participative Learning */}
          {activeTab === "participative" && (
            <>
              <h2 className="mob-section-title">Participative Learning</h2>
              <h3 className="mob-subsection-title">Guest Lecture:</h3>
              <p className="mob-section-desc">Guest lectures provide students with interactive sessions led by industry experts, offering insights into current trends and real-world practices. These sessions encourage students to engage in dialogue, ask questions, and learn through discussion and reflection, bridging the gap between academic learning and industry expectations.</p>
              
              <h3 className="mob-subsection-title">Green Club:</h3>
              <p className="mob-section-desc">Conducts eco-friendly initiatives such as tree plantations, beach clean-ups, and awareness drives.</p>
              
              <h3 className="mob-subsection-title">Gallery</h3>
              <div className="mob-photo-grid">
                {participativeImages.map((img, idx) => (
                  <div key={idx} className="mob-photo-item">
                    <img src={`${basePath}/${img}`} alt={`Participative Learning Event ${idx + 1}`} />
                  </div>
                ))}
              </div>
            </>
          )}

          {/* TAB 4: Experiential Learning */}
          {activeTab === "experiential" && (
            <>
              <h2 className="mob-section-title">Experiential Learning</h2>
              <p className="mob-section-desc">Experiential Learning at TIMSCDR focuses on learning through real-world experiences such as industrial visits, professional chapters, student clubs. It enables students to apply theoretical knowledge in practical settings, enhancing their problem-solving, teamwork, and professional skills.</p>
              
              <h3 className="mob-subsection-title">Synapse :</h3>
              <p className="mob-section-desc">SYNAPSE event is organised every year. The event is designed to innovate and create unique IT products. Synapse encourages students to think ‘out-of-box’.</p>

              <h3 className="mob-subsection-title">E-Cell (Entrepreneurship Cell):</h3>
              <p className="mob-section-desc">To promote a sense of Entrepreneurship amongst the students. The main purpose of the event is to provide a platform for students to showcase and sell their products and improve their entrepreneurship skills.</p>

              <h3 className="mob-subsection-title">DLLE & Industrial Visits:</h3>
              <p className="mob-section-desc">TIMSCDR fosters social awareness through collaborations with NGOs like INSEED and initiatives such as the DLLE program. Industrial visits provide real-world exposure, linking classroom learning to industry practices.</p>

              <div className="mob-obj-container">
                <div className="mob-obj-card">
                  <div className="mob-obj-icon-box"><TargetIcon /></div>
                  <div className="mob-obj-content">
                    <h3 className="mob-obj-title">OBJECTIVE</h3>
                    <ul className="mob-obj-list">
                      <li>To enhance learning through direct, real-world experiences that connect theory with practical application.</li>
                      <li>To develop entrepreneurial, social, and professional competencies through activities like E-Cell, DLLE, and industrial visits.</li>
                    </ul>
                  </div>
                </div>
                <div className="mob-obj-card">
                  <div className="mob-obj-icon-box"><TrendingUpIcon /></div>
                  <div className="mob-obj-content">
                    <h3 className="mob-obj-title">OUTCOME</h3>
                    <ul className="mob-obj-list">
                      <li>Students apply classroom knowledge to practical contexts, improving problem-solving skills.</li>
                      <li>Learners demonstrate entrepreneurial thinking and leadership through participation in events.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* TAB 5: Research Based Learning */}
          {activeTab === "research" && (
            <>
              <h2 className="mob-section-title">Research Based Learning</h2>
              <p className="mob-section-desc">Under the Research-Based Learning (RBL) approach, students actively engage in exploring new ideas through the Research, Innovation, and Technology Lab. They are encouraged to investigate emerging technologies, develop innovative solutions, and contribute to knowledge creation.</p>
              
              <h3 className="mob-subsection-title">Research, Innovation and Technology Lab (RITL):</h3>
              <p className="mob-section-desc">The RIT Lab aims to foster innovation and technological advancement by promoting hands-on learning in IoT and emerging technologies.</p>
              
              <h3 className="mob-subsection-title">Conference Presentations:</h3>
              <p className="mob-section-desc">Students present research posters and papers showcasing their innovative ideas and findings on emerging technologies and management topics during International Conferences (ICAIM).</p>

              <div className="mob-obj-container">
                <div className="mob-obj-card">
                  <div className="mob-obj-icon-box"><TargetIcon /></div>
                  <div className="mob-obj-content">
                    <h3 className="mob-obj-title">OBJECTIVE</h3>
                    <ul className="mob-obj-list">
                      <li>To promote inquiry-driven learning that encourages exploration and innovation.</li>
                      <li>To develop analytical, problem-solving, and academic writing skills.</li>
                    </ul>
                  </div>
                </div>
                <div className="mob-obj-card">
                  <div className="mob-obj-icon-box"><TrendingUpIcon /></div>
                  <div className="mob-obj-content">
                    <h3 className="mob-obj-title">OUTCOME</h3>
                    <ul className="mob-obj-list">
                      <li>Students apply systematic research methods to analyse and propose solutions.</li>
                      <li>Learners demonstrate critical thinking, creativity, and data-driven decision-making.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* TAB 6: Teaching Pedagogy */}
          {activeTab === "pedagogy" && (
            <>
              <h2 className="mob-section-title">Teaching Pedagogy</h2>
              <p className="mob-section-desc">Various methodologies employed to enhance student learning and engagement.</p>
              
              <div className="mob-pedagogy-cards">
                {pedagogyData.map((item) => (
                  <div key={item.id} className="mob-obj-card" style={{flexDirection: 'column', gap: '10px'}}>
                    <h3 className="mob-obj-title" style={{margin:0}}>{item.pedagogy}</h3>
                    <p className="mob-section-desc" style={{margin:0, color:'#475569'}}>{item.impact}</p>
                    {(item.exampleText || (item.exampleList && item.exampleList.length > 0)) && (
                      <div style={{background: '#ffffff', padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0', width: '100%'}}>
                        <strong style={{fontSize:'11px', color:'#94a3b8', textTransform:'uppercase'}}>Example / Course:</strong>
                        <p style={{fontSize:'12px', margin:'5px 0 0 0', color:'#334155'}}>{item.exampleText}</p>
                        {item.exampleList && (
                          <ul style={{fontSize:'12px', margin:'5px 0 0 0', paddingLeft:'15px', color:'#334155'}}>
                            {item.exampleList.map((ex, i) => <li key={i}>{ex}</li>)}
                          </ul>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}

          {/* TAB 7: Semester Case Study */}
          {activeTab === "semester" && (
            <>
              <h2 className="mob-section-title">Semester Case Study: SYNAPSE</h2>
              <p className="mob-section-desc">TIMSCDR conceptualized the event “SYNAPSE – junction between two neurons – Technology and Innovations” to inculcate self-learning, innovation and entrepreneurship amongst its students.</p>
              
              <h3 className="mob-subsection-title">Stages of SYNAPSE</h3>
              <p className="mob-section-desc">SYNAPSE consists of two stages – Curtain Raiser and Final Presentation. Products are mentored by faculty members regularly and by industry professionals periodically.</p>
              
              <h3 className="mob-subsection-title">Key Elements</h3>
              <ul className="mob-obj-list" style={{marginBottom: '20px'}}>
                <li>Existing system / Problem statement</li>
                <li>Proposed system and its USP</li>
                <li>Feasibility study</li>
                <li>Deployment / Plan of execution</li>
                <li>Prototype</li>
                <li>Societal or business impact (ROI) expected</li>
              </ul>

              <div className="mob-obj-container">
                <div className="mob-obj-card">
                  <div className="mob-obj-icon-box"><TargetIcon /></div>
                  <div className="mob-obj-content">
                    <h3 className="mob-obj-title">UNIQUE FEATURES</h3>
                    <ul className="mob-obj-list">
                      <li>100% student participation.</li>
                      <li>Providing seed money to all groups to develop prototypes.</li>
                      <li>Continuous mentoring by faculty and Industry professionals.</li>
                      <li>Certificates and cash prize given to winners.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          )}

        </div>
      </div>

      <Footer />
    </>
  );
};

export default ICTBasedLearning;
